export default __webpack_public_path__ + "external-link-symbol.png";